export default __webpack_public_path__ + "static/SRF 1085 - Fiche de spécifications et données techniques-73adb0282c28614caccd08236860e358.pdf";